import { useLanguage } from "@/i18n";

import { MaintenanceBanner } from "./MaintenanceBanner";
import { MaintenanceBlockScreen } from "./MaintenanceBlockScreen";
import { useMaintenanceState } from "./useMaintenanceState";

/**
 * Scheduled-maintenance banner / block screen driven by Firebase Remote Config.
 * Renders nothing until the config loads and nothing when it fails, so an
 * unreachable Firebase never blocks the app.
 */
export const MaintenanceNotice = () => {
  const [locale] = useLanguage();
  const { config, schedule, phase, isDismissed, dismiss } = useMaintenanceState();

  if (!config) return null;

  if (config.enabled || (schedule && phase === "inProgress" && schedule.blockDuring)) {
    // The kill switch alone shows the default texts; a schedule's own texts and times only
    // apply while its window is running.
    return (
      <MaintenanceBlockScreen schedule={phase === "inProgress" ? schedule : null} locale={locale} />
    );
  }

  if (!schedule || phase === "none" || isDismissed) return null;

  return (
    <MaintenanceBanner
      schedule={schedule}
      phase={phase}
      locale={locale}
      onDismiss={schedule.dismissible ? dismiss : undefined}
    />
  );
};
